(function () {
  'use strict';

  function initCharCounters() {
    document.querySelectorAll('[data-char-limit]').forEach(function (el) {
      var limit = parseInt(el.getAttribute('data-char-limit'), 10);
      var counter = document.getElementById(el.id + '-counter');
      if (!counter) return;
      var reveal = Math.floor(limit * 0.8);
      function update() {
        var len = el.value.length;
        counter.textContent = len + ' / ' + limit;
        counter.classList.toggle('lcu-form__counter--warn', len > limit * 0.9);
        counter.classList.toggle('lcu-form__counter--hidden', len < reveal);
      }
      el.addEventListener('input', update);
      update();
    });
  }


  /**
   * Affiche un message d'erreur custom sur les radios occasion (invisibles via CSS,
   * donc le message HTML5 natif n'apparaît pas). On écoute l'event 'invalid' qui
   * se déclenche au submit form quand aucun radio n'est sélectionné.
   */
  function initOccasionValidation() {
    var radios = document.querySelectorAll('input[name="properties[Occasion]"]');
    var errorEl = document.getElementById('lcu-occasion-error');
    if (!radios.length || !errorEl) return;

    radios.forEach(function (radio) {
      radio.addEventListener('invalid', function (e) {
        // Empêche le tooltip natif (qui ne s'affiche pas car l'input est hidden)
        e.preventDefault();
        errorEl.hidden = false;
        // Scroll smoothly vers le message d'erreur (sous les cards)
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      radio.addEventListener('change', function () {
        if (radio.checked) errorEl.hidden = true;
      });
    });
  }

  function initConditionalFields() {
    document.querySelectorAll('[data-toggle-target]').forEach(function (trigger) {
      var targetId = trigger.getAttribute('data-toggle-target');
      var targetValue = trigger.getAttribute('data-toggle-value');
      var target = document.getElementById(targetId);
      if (!target) return;
      var name = trigger.getAttribute('name');
      var group = document.querySelectorAll('[name="' + name + '"]');
      function update() {
        var checked = document.querySelector('[name="' + name + '"]:checked');
        var show = checked && checked.value === targetValue;
        target.hidden = !show;
        target.setAttribute('aria-hidden', String(!show));
        var input = target.querySelector('input, textarea, select');
        if (input) {
          if (show) { input.removeAttribute('tabindex'); }
          else { input.setAttribute('tabindex', '-1'); }
        }
      }
      group.forEach(function (r) { r.addEventListener('change', update); });
      update();
    });

    document.querySelectorAll('select[data-toggle-select-target]').forEach(function (select) {
      var targetId = select.getAttribute('data-toggle-select-target');
      var target = document.getElementById(targetId);
      if (!target) return;
      function update() {
        var selected = select.options[select.selectedIndex];
        var show = selected && selected.hasAttribute('data-toggle-other');
        target.hidden = !show;
        target.setAttribute('aria-hidden', String(!show));
        var input = target.querySelector('input, textarea, select');
        if (input) {
          if (show) { input.removeAttribute('tabindex'); }
          else { input.setAttribute('tabindex', '-1'); input.value = ''; }
        }
      }
      select.addEventListener('change', update);
      update();
    });
  }

  function initSummary() {
    var summary = document.getElementById('lcu-summary');
    if (!summary) return;
    var form = summary.closest('form') || document.querySelector('.lcu-product-form');
    if (!form) return;
    function update() {
      form.querySelectorAll('[data-summary-key]').forEach(function (el) {
        var key = el.getAttribute('data-summary-key');
        var slot = summary.querySelector('[data-summary-slot="' + key + '"]');
        if (!slot) return;
        var val = '';
        if (el.type === 'radio') {
          var checked = form.querySelector('[data-summary-key="' + key + '"]:checked');
          val = checked ? (checked.getAttribute('data-summary-label') || checked.value) : '';
        } else {
          val = el.value;
        }
        slot.textContent = val || '—';
      });
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    update();
  }

  function initPriceUpdate() {
    var btn = document.querySelector('[data-lcu-price-btn]');
    if (!btn) return;
    var base = parseFloat(btn.getAttribute('data-base-price')) || 0;
    var suffix = btn.getAttribute('data-currency-suffix') || '€';
    var form = btn.closest('form') || document.querySelector('.lcu-product-form');
    if (!form) return;
    function update() {
      /* Re-query chaque fois : après un add-to-cart, innerHTML du bouton est restauré
         depuis data-original-text, ce qui orphaneline l'ancienne référence du span. */
      var label = btn.querySelector('[data-price-display]');
      if (!label) return;
      var total = base;
      form.querySelectorAll('[data-option-price]:checked').forEach(function (el) {
        total += parseFloat(el.getAttribute('data-option-price')) || 0;
      });
      var display = total % 1 === 0 ? total.toFixed(0) : total.toFixed(2).replace('.', ',');
      /* suffix inclut son propre espacement (ex: "€", " $") pour respecter la typo locale */
      label.textContent = display + suffix;
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = display + suffix;
    }
    form.addEventListener('change', update);
    update();
  }

  function formatLocalTime() {
    var d = new Date();
    var locale = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0 ? 'en-US' : 'fr-FR';
    try {
      return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(d);
    } catch (e) {
      var h = String(d.getHours()).padStart(2, '0');
      var m = String(d.getMinutes()).padStart(2, '0');
      return h + ':' + m;
    }
  }

  function updateUrgencyTimestamp() {
    var nodes = document.querySelectorAll('[data-lcu-urgency-time]');
    if (!nodes.length) return false;
    var stamp = formatLocalTime();
    nodes.forEach(function (node) {
      if (stamp && stamp !== '—') node.textContent = stamp;
    });
    return true;
  }

  function initUrgencyTimestamp() {
    // Try immediately; if nodes are not yet in DOM (cache hydration), retry a few times.
    if (updateUrgencyTimestamp()) return;
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (updateUrgencyTimestamp() || attempts >= 10) clearInterval(retry);
    }, 300);
  }

  /**
   * Sélecteur de livraison dynamique en fonction de l'heure courante (Europe/Paris).
   *
   * Plage de traitement : 6h-00h. Commandes de nuit (00h-06h) → compteur démarre à 6h.
   * Wording adapté pour ne jamais casser la promesse perçue par le client.
   *
   * Tracking : push event 'lcu_delivery_tier_selected' dans dataLayer au change d'option.
   * Fallback no-JS : strings statiques rendues côté Liquid restent affichées.
   */
  function initDeliverySelector() {
    var root = document.querySelector('[data-lcu-delivery-selector]');
    if (!root) return;

    // Heure courante en Europe/Paris quel que soit le fuseau navigateur
    function nowInParis() {
      try {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          hour: '2-digit', minute: '2-digit', hour12: false
        });
        var parts = {};
        fmt.formatToParts(new Date()).forEach(function (p) {
          if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10);
        });
        return { hour: parts.hour === 24 ? 0 : parts.hour, minute: parts.minute };
      } catch (e) {
        var d = new Date();
        return { hour: d.getHours(), minute: d.getMinutes() };
      }
    }

    /**
     * Wording basé directement sur l'heure courante (Europe/Paris).
     * Plage de traitement : 6h-00h. Commandes nuit (00h-06h) → start clampé à 6h.
     *
     * Garantie de hiérarchie : Flash plus tôt que Express plus tôt que Standard,
     * sauf à 18h pile où Flash converge avec Express → on désactive Flash visuellement.
     */
    function buildWording(tier, h) {
      var isNight = h < 6;
      var etaH;

      if (tier === 'standard') {
        if (isNight) return 'Avant demain matin';
        return 'Avant demain ' + h + 'h';
      }

      if (tier === 'express') {
        if (isNight) return 'Avant ce soir 18h';
        if (h < 12) {
          // matin → ETA = soir same day
          etaH = h + 12;
          return 'Avant ce soir ' + etaH + 'h';
        }
        if (h < 18) {
          // après-midi → ETA brut tombe en pleine nuit, clamp à 6h demain
          return 'Avant demain 6h';
        }
        // soir 18h-23h → ETA matin demain (6h-11h)
        etaH = (h + 12) % 24;
        return 'Avant demain ' + etaH + 'h';
      }

      if (tier === 'flash') {
        if (isNight) return 'Avant midi';
        if (h < 12) {
          etaH = h + 6;
          return 'Avant ' + etaH + 'h';
        }
        if (h < 18) {
          etaH = h + 6;
          return 'Avant ce soir ' + etaH + 'h';
        }
        // soir 18h-23h → ETA brut tombe en pleine nuit → clamp 6h demain
        return 'Avant demain 6h';
      }
      return '';
    }

    function buildBenefit(tier, h) {
      // Standard 24h : ETA toujours = même heure le lendemain → "demain" est tjr cohérent
      if (tier === 'standard') return 'Pour offrir demain';

      // Express 12h : statique, marche à toutes les heures (tjr plus tôt que 24h)
      if (tier === 'express') return 'Pour offrir plus tôt';

      // Flash 6h : statique, marche à toutes les heures (superlatif logique vs Express "plus tôt")
      if (tier === 'flash') return 'Pour offrir au plus vite';
      return '';
    }

    var DISABLED_TEXT = 'Disponible à partir de 6h demain';

    function update() {
      var paris = nowInParis();
      var h = paris.hour;
      // Flash converge avec Express pendant l'heure 18h (Express ETA = 6h-7h, Flash ETA = 6h).
      // On désactive Flash sur cette heure pour préserver la hiérarchie visuelle.
      var flashDisabled = (h === 18);

      root.querySelectorAll('.lcu-delivery-selector__option').forEach(function (option) {
        var tier = option.getAttribute('data-delivery-tier');
        var input = option.querySelector('input[type="radio"]');
        if (!tier || !input) return;

        var etaNode = option.querySelector('[data-delivery-eta]');
        var benefitNode = option.querySelector('[data-delivery-benefit]');

        if (tier === 'flash' && flashDisabled) {
          option.classList.add('lcu-delivery-selector__option--disabled');
          input.disabled = true;
          if (input.checked) {
            input.checked = false;
            var fallback = root.querySelector('input[name="properties[Délai de livraison]"]:not([disabled])');
            if (fallback) {
              fallback.checked = true;
              fallback.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          if (etaNode) etaNode.textContent = DISABLED_TEXT;
          if (benefitNode) benefitNode.textContent = '';
        } else {
          option.classList.remove('lcu-delivery-selector__option--disabled');
          input.disabled = false;
          if (etaNode) etaNode.textContent = buildWording(tier, h);
          if (benefitNode) benefitNode.textContent = buildBenefit(tier, h);
        }
      });
    }

    // Tracking : push event au changement d'option dans dataLayer
    root.querySelectorAll('input[name="properties[Délai de livraison]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!this.checked) return;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'lcu_delivery_tier_selected',
            delivery_tier: this.value,
            delivery_price: parseFloat(this.getAttribute('data-option-price')) || 0
          });
        } catch (e) { /* silent */ }
      });
    });

    update();
  }

  function initDeliveryVariantSwitch() {
    if (!_form) return;
    var variantInput = _form.querySelector('input[name="id"]');
    if (!variantInput) return;

    function applyVariant(radio) {
      if (radio && radio.dataset.variantId) {
        variantInput.value = radio.dataset.variantId;
      }
    }

    // Set initial variant from the pre-checked radio
    applyVariant(document.querySelector('.lcu-delivery-selector__radio:checked'));

    document.querySelectorAll('.lcu-delivery-selector__radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applyVariant(radio);
      });
    });
  }

  function initUpsellCartSubmit() {
    var form = document.querySelector('.lcu-product-form');
    if (!form) return;

    var isSubmitting = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (isSubmitting) return;
      isSubmitting = true;

      var submitBtn = form.querySelector('[data-lcu-price-btn]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Ajout en cours\u2026';
      }

      // Collect line item properties from form inputs
      var formData = new FormData(form);
      var properties = {};
      formData.forEach(function (val, key) {
        if (key.indexOf('properties[') === 0) {
          var propKey = key.slice(11, -1);
          if (val !== '') properties[propKey] = val;
        }
      });

      // Main product item : variant dérivé du radio checked (même source que la
      // property "Délai de livraison"). Garantit qu'ils ne peuvent jamais
      // desync — cf. incident desync STD-48 vs Prioritaire 6h.
      var checkedDeliveryRadio = form.querySelector('.lcu-delivery-selector__radio:checked');
      var variantId = checkedDeliveryRadio && checkedDeliveryRadio.dataset.variantId
        ? parseInt(checkedDeliveryRadio.dataset.variantId, 10)
        : parseInt(formData.get('id'), 10);

      if (!variantId || isNaN(variantId)) {
        console.error('[LCU] Variant id manquant au submit');
        isSubmitting = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = submitBtn.getAttribute('data-original-text') || 'Ajouter au panier';
        }
        return;
      }

      // Collect add-on upsell items (no properties)
      var addonItems = [];
      document.querySelectorAll('.lcu-inline-option').forEach(function (label) {
        var checkbox = label.querySelector('.lcu-inline-option__checkbox');
        if (checkbox && checkbox.checked && label.dataset.variantId) {
          addonItems.push({
            id: parseInt(label.dataset.variantId, 10),
            quantity: 1
          });
        }
      });
      document.querySelectorAll('.lcu-voice-selector__option[data-variant-id]').forEach(function (label) {
        var radio = label.querySelector('.lcu-voice-selector__radio');
        if (radio && radio.checked) {
          addonItems.push({
            id: parseInt(label.dataset.variantId, 10),
            quantity: 1
          });
        }
      });

      // On retire les variants main avant de ré-ajouter pour garantir qty 1.
      // Les upsells (couplets, streaming) ajoutés depuis le drawer sont préservés.
      var mainVariantIds = [];
      document.querySelectorAll('.lcu-delivery-selector__radio[data-variant-id]').forEach(function (radio) {
        var id = parseInt(radio.getAttribute('data-variant-id'), 10);
        if (id && mainVariantIds.indexOf(id) === -1) mainVariantIds.push(id);
      });

      var removeChain = Promise.resolve();
      mainVariantIds.forEach(function (vid) {
        removeChain = removeChain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(vid), quantity: 0 })
          }).catch(function () { /* variant absent : no-op */ });
        });
      });

      // Sections param sur le DERNIER fetch uniquement → la réponse contient
      // le HTML à passer à cartDrawer.renderContents().
      var cartDrawer = document.querySelector('cart-drawer');
      var drawerSections = '';
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        drawerSections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      }

      removeChain
        .then(function () {
          // Addons (phrase, voix) = toggles binaires → max qty 1.
          // On filtre ceux déjà au panier pour ne pas incrémenter à chaque clic.
          if (addonItems.length === 0) return [];
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var existingIds = {};
              (cart.items || []).forEach(function (item) {
                if (item.quantity > 0) existingIds[item.id] = true;
              });
              return addonItems.filter(function (it) { return !existingIds[it.id]; });
            })
            .catch(function () { return addonItems; });
        })
        .then(function (filteredAddons) {
          var body = { id: variantId, quantity: 1, properties: properties };
          if (filteredAddons.length === 0 && drawerSections) {
            body.sections = drawerSections;
            body.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Erreur panier'); });
            return res.json();
          }).then(function (mainResp) {
            return { mainResp: mainResp, filteredAddons: filteredAddons };
          });
        })
        .then(function (state) {
          if (state.filteredAddons.length === 0) return state.mainResp;
          var body = { items: state.filteredAddons };
          if (drawerSections) {
            body.sections = drawerSections;
            body.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Erreur panier'); });
            return res.json();
          });
        })
        .then(function (finalResp) {
          try {
            if (sessionStorage.getItem('lcu_was_editing') === '1') {
              localStorage.removeItem('lcu_song_snapshot');
              sessionStorage.removeItem('lcu_was_editing');
            }
          } catch (e) {}

          clearDraft();

          if (cartDrawer && finalResp && finalResp.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(finalResp);

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lcu-product', cartData: finalResp });
            }

            isSubmitting = false;
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = submitBtn.getAttribute('data-original-text') || 'Ajouter au panier';
            }
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[LCU] Cart error:', err);
          isSubmitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = submitBtn.getAttribute('data-original-text') || 'Ajouter au panier';
          }
        });
    });

    // Store original button text for error recovery
    var submitBtn = form.querySelector('[data-lcu-price-btn]');
    if (submitBtn) submitBtn.setAttribute('data-original-text', submitBtn.innerHTML);
  }

  // ─── Shared helpers : setter une valeur + dispatch les events adéquats ───
  var _form = null;

  function cssEscape(s) {
    return String(s).replace(/(["\\])/g, '\\$1');
  }
  function setTextValue(el, value) {
    if (!el) return false;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function setRadioByValue(name, value) {
    if (!_form) return false;
    var radio = _form.querySelector(
      'input[type="radio"][name="' + name + '"][value="' + cssEscape(value) + '"]'
    );
    if (!radio) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function setSelectValue(name, value) {
    if (!_form) return false;
    var select = _form.querySelector('select[name="' + name + '"]');
    if (!select) return false;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function setCheckbox(name, checked) {
    if (!_form) return false;
    var cb = _form.querySelector('input[type="checkbox"][name="' + name + '"]');
    if (!cb) return false;
    cb.checked = !!checked;
    cb.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /**
   * Pré-remplit le formulaire produit depuis sessionStorage.lcu_pending_song_edit
   * quand le client revient d'un clic "Modifier" sur le cart drawer.
   *
   * Source de vérité : le mapping des champs est documenté dans l'audit du flow édition.
   * One-shot : la clé sessionStorage est vidée après remplissage pour ne pas re-remplir
   * si le client navigue ailleurs et revient sur la page produit.
   */
  function initPrefillFromSnapshot() {
    if (!_form) return;

    var raw;
    try {
      raw = sessionStorage.getItem('lcu_pending_song_edit');
    } catch (e) {
      return;
    }
    if (!raw) return;

    var snapshot;
    try {
      snapshot = JSON.parse(raw);
    } catch (e) {
      sessionStorage.removeItem('lcu_pending_song_edit');
      return;
    }

    // TTL 30 min pour le pending edit (pas le snapshot localStorage 24h)
    if (!snapshot || !snapshot.timestamp || Date.now() - snapshot.timestamp > 30 * 60 * 1000) {
      sessionStorage.removeItem('lcu_pending_song_edit');
      return;
    }

    var props = snapshot.properties || {};

    // Mapping connu : clés name exactes utilisées dans le form (cf. audit)
    var KNOWN_KEYS = [
      'Prénom', 'Lien',
      'Occasion', 'Occasion (autre)',
      'Souvenirs', 'Phrase personnalisée',
      'Style musical', 'Style musical (autre)', 'Ambiance', 'Voix', 'Délai de livraison'
    ];

    // Rétrocompatibilité : si le snapshot vient d'une ancienne commande "Pour qui",
    // on essaie de splitter la valeur en prenom + lien.
    if (props['Pour qui'] && !props['Prénom']) {
      var compound = String(props['Pour qui']);
      compound = compound.replace(/\((\d+)\s*ans?\)/i, '').trim();
      var commaIdx = compound.indexOf(',');
      if (commaIdx > 0) {
        props['Prénom'] = compound.slice(0, commaIdx).trim();
        if (!props['Lien']) props['Lien'] = compound.slice(commaIdx + 1).trim();
      } else {
        props['Prénom'] = compound;
      }
    }

    Object.keys(props).forEach(function (key) {
      var value = props[key];
      if (value == null || value === '') return;

      var handled = false;

      switch (key) {
        case 'Prénom':
          handled = setTextValue(document.getElementById('lcu-prenom'), value);
          break;
        case 'Lien':
          handled = setTextValue(document.getElementById('lcu-lien'), value);
          break;
        case 'Âge':
        case 'Pour qui':
          // Clés legacy : gérées ci-dessus, on ignore
          handled = true;
          break;
        case 'Occasion':
          handled = setRadioByValue('properties[Occasion]', value);
          break;
        case 'Occasion (autre)':
          handled = setTextValue(document.getElementById('lcu-occasion-other-input'), value);
          break;
        case 'Souvenirs':
          handled = setTextValue(document.getElementById('lcu-souvenirs'), value);
          break;
        case 'Phrase personnalisée':
          // Révèle le champ en cochant la checkbox parente
          var phraseCheckbox = document.querySelector('[data-checkbox-reveal="lcu-phrase-field"]');
          if (phraseCheckbox && !phraseCheckbox.checked) {
            phraseCheckbox.checked = true;
            phraseCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          handled = setTextValue(document.getElementById('lcu-phrase'), value);
          break;
        case 'Style musical':
          handled = setSelectValue('properties[Style musical]', value);
          break;
        case 'Style musical (autre)':
          handled = setTextValue(document.getElementById('lcu-style-other-input'), value);
          break;
        case 'Ambiance':
          handled = setSelectValue('properties[Ambiance]', value);
          break;
        case 'Voix':
          handled = setRadioByValue('properties[Voix]', value);
          break;
        case 'Délai de livraison':
          handled = setRadioByValue('properties[Délai de livraison]', value);
          break;
        default:
          // Clé inconnue : probablement une checkbox upsell (label dynamique)
          handled = setCheckbox('properties[' + key + ']', value === 'Oui' || value === true);
          break;
      }

      if (!handled && KNOWN_KEYS.indexOf(key) !== -1) {
        console.warn('[LCU] Impossible de pré-remplir le champ "' + key + '" (champ introuvable)');
      }
    });

    // One-shot : on vide la clé de pré-remplissage. Le flag lcu_was_editing et
    // le snapshot localStorage restent en place jusqu'à ce que le form soit resoumis.
    try {
      sessionStorage.removeItem('lcu_pending_song_edit');
    } catch (e) {}

    // Notification visuelle dismissible
    showEditNotification(_form);
  }

  function showEditNotification(form) {
    if (document.getElementById('lcu-edit-notice')) return;

    var notice = document.createElement('div');
    notice.id = 'lcu-edit-notice';
    notice.className = 'lcu-edit-notice';
    notice.setAttribute('role', 'status');
    notice.innerHTML =
      '<span class="lcu-edit-notice__icon" aria-hidden="true">\u270F\uFE0F</span>' +
      '<span class="lcu-edit-notice__text">Vous modifiez votre chanson\u00A0\u2014 vos informations pr\u00E9c\u00E9dentes ont \u00E9t\u00E9 restaur\u00E9es.</span>' +
      '<button type="button" class="lcu-edit-notice__close" aria-label="Fermer">\u00D7</button>';

    form.insertBefore(notice, form.firstChild);

    var dismissed = false;
    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      notice.classList.add('is-dismissing');
      setTimeout(function () {
        if (notice && notice.parentNode) notice.parentNode.removeChild(notice);
      }, 250);
    }

    notice.querySelector('.lcu-edit-notice__close').addEventListener('click', dismiss);
    // Dismiss au premier focus sur un champ
    form.addEventListener('focusin', dismiss, { once: true });
    // Dismiss auto après 8s
    setTimeout(dismiss, 8000);
  }

  // ─── Auto-save draft : persiste les champs au fur et à mesure ─────────
  var DRAFT_KEY = 'lcu_form_draft';
  var DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

  function initAutoSaveDraft() {
    if (!_form) return;

    var debounceTimer = null;

    function collectFormData() {
      var props = {};
      _form.querySelectorAll('input[type="text"][name^="properties["], textarea[name^="properties["]')
        .forEach(function (el) { props[el.name.slice(11, -1)] = el.value; });
      _form.querySelectorAll('select[name^="properties["]')
        .forEach(function (el) { props[el.name.slice(11, -1)] = el.value; });
      _form.querySelectorAll('input[type="radio"][name^="properties["]:checked')
        .forEach(function (el) { props[el.name.slice(11, -1)] = el.value; });
      _form.querySelectorAll('input[type="checkbox"][name^="properties["]')
        .forEach(function (el) {
          if (el.checked) props[el.name.slice(11, -1)] = el.value || 'Oui';
        });
      return props;
    }

    function saveDraft() {
      var props = collectFormData();
      var hasContent = Object.keys(props).some(function (k) {
        if (k === 'Délai de livraison' || k === 'Voix') return false;
        return props[k] !== '';
      });
      if (!hasContent) return;
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({
          saved_at: Date.now(),
          properties: props
        }));
      } catch (e) { /* quota exceeded or private mode */ }
    }

    function debouncedSave() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(saveDraft, 500);
    }

    _form.addEventListener('input', debouncedSave);
    _form.addEventListener('change', debouncedSave);
  }

  function clearDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
  }

  // ─── Restore draft : restaure les champs depuis localStorage ──────────
  function initRestoreDraft() {
    if (!_form) return;

    // Priorité : si le cart-edit a déjà pré-rempli, on ne restore pas le draft
    try {
      if (sessionStorage.getItem('lcu_was_editing') === '1') return;
    } catch (e) {}

    var raw;
    try { raw = localStorage.getItem(DRAFT_KEY); } catch (e) { return; }
    if (!raw) return;

    var draft;
    try { draft = JSON.parse(raw); } catch (e) {
      localStorage.removeItem(DRAFT_KEY);
      return;
    }

    if (!draft || !draft.saved_at || Date.now() - draft.saved_at > DRAFT_TTL_MS) {
      localStorage.removeItem(DRAFT_KEY);
      return;
    }

    var props = draft.properties || {};

    Object.keys(props).forEach(function (key) {
      var value = props[key];
      if (value == null || value === '') return;

      switch (key) {
        case 'Prénom':
          setTextValue(document.getElementById('lcu-prenom'), value);
          break;
        case 'Lien':
          setTextValue(document.getElementById('lcu-lien'), value);
          break;
        case 'Occasion':
          setRadioByValue('properties[Occasion]', value);
          break;
        case 'Occasion (autre)':
          setTextValue(document.getElementById('lcu-occasion-other-input'), value);
          break;
        case 'Souvenirs':
          setTextValue(document.getElementById('lcu-souvenirs'), value);
          break;
        case 'Phrase personnalisée':
          var phraseCheckbox = document.querySelector('[data-checkbox-reveal="lcu-phrase-field"]');
          if (phraseCheckbox && !phraseCheckbox.checked) {
            phraseCheckbox.checked = true;
            phraseCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          setTextValue(document.getElementById('lcu-phrase'), value);
          break;
        case 'Style musical':
          setSelectValue('properties[Style musical]', value);
          break;
        case 'Style musical (autre)':
          setTextValue(document.getElementById('lcu-style-other-input'), value);
          break;
        case 'Ambiance':
          setSelectValue('properties[Ambiance]', value);
          break;
        case 'Voix':
          setRadioByValue('properties[Voix]', value);
          break;
        case 'Délai de livraison':
          setRadioByValue('properties[Délai de livraison]', value);
          break;
        default:
          setCheckbox('properties[' + key + ']', value === 'Oui' || value === true);
          break;
      }
    });
  }

  function init() {
    _form = document.querySelector('.lcu-product-form');
    initCharCounters();
    initConditionalFields();
    initOccasionValidation();
    initSummary();
    initPriceUpdate();
    initDeliverySelector();
    initUrgencyTimestamp();
    initDeliveryVariantSwitch();
    initUpsellCartSubmit();
    // Pré-remplit le form depuis un snapshot d'édition, puis vide la clé one-shot.
    // Doit tourner APRÈS l'init des listeners pour que les dispatch d'events
    // déclenchent correctement les calculs de prix + variant updates.
    initPrefillFromSnapshot();
    // Restore le draft auto-save (skip si cart-edit a déjà pré-rempli)
    initRestoreDraft();
    // Commence à écouter les changements pour auto-sauvegarder
    initAutoSaveDraft();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
